import React from 'react'
import DashboardSectionCard from '@components/pages/Dashboard/DashboardSectionCard.component'
import { huddlePerformanceVsGoalHasData } from '@utils/dashboardHuddle.util'
import {
  isDashboardSectionPending,
  shouldShowDashboardSectionEmpty,
} from '@utils/dashboardSectionEmpty.util'
import type { HuddleDashboard } from '../useHuddleDashboard'
import { HuddleMetricGrid } from '../HuddleMetricGrid.component'

type PerformanceVsGoalCardProps = {
  titleHref: string
  performance: HuddleDashboard['yesterdayPerformanceApi']
  className?: string
}

export function PerformanceVsGoalCard({
  titleHref,
  performance,
  className = 'dashboard-huddle-yesterday-card',
}: PerformanceVsGoalCardProps): React.ReactElement {
  const { summaryMetrics, loading, data } = performance
  const isEmpty = shouldShowDashboardSectionEmpty(
    loading,
    huddlePerformanceVsGoalHasData(data),
  )
  const pending = isDashboardSectionPending(loading, data != null)

  return (
    <DashboardSectionCard
      title="Performance vs goal"
      titleHref={titleHref}
      className={className}
      loading={pending}
      skeleton={{ metrics: 4 }}
      isEmpty={isEmpty}
    >
      <HuddleMetricGrid metrics={summaryMetrics} />
    </DashboardSectionCard>
  )
}
